import { z } from "zod";
import { differenceInHours, isValid, parseISO, sub } from "date-fns";

import { LEGAL_NAME } from "utilities/regex";

export const userVerificationSchema = z.object({
  firstName: z
    .string()
    .min(1, "A first name is required")
    .regex(LEGAL_NAME, "Invalid first name"),
  lastName: z
    .string()
    .min(1, "A last name is required")
    .regex(LEGAL_NAME, "Invalid last name"),
  dateOfBirth: z
    .string()
    .min(1, "A valid date of birth is required")
    .refine(
      (dob) => {
        const date = parseISO(dob);
        return (
          isValid(date) &&
          differenceInHours(sub(new Date(), { years: 18 }), date) >= 0
        );
      },
      { message: "You must be at least 18 years old" },
    ),
  consent: z.boolean().refine((val) => val === true, {
    message: "You must consent to Picklebet checking the information above.",
  }),
});

export type UserVerificationFormValues = z.infer<typeof userVerificationSchema>;
